import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Payment } from '@/models/types';
import { Button } from '../../ui/button';
import { PAYMENT_TYPE_OPTIONS_MAP } from './payment-type-selector-combobox';

export const PaymentTypeBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  useAbbreviation = false,
}: {
  value: Payment['type'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  useAbbreviation?: boolean;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Contract Status</p>
        </>
      )}
      {PAYMENT_TYPE_OPTIONS_MAP.map((option) => {
        if (option.value === value) {
          return <div key={option.value}>{option.icon}</div>;
        }
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? PAYMENT_TYPE_OPTIONS_MAP.find((option) => option.value === value)
                ?.abbreviation
            : PAYMENT_TYPE_OPTIONS_MAP.find((option) => option.value === value)
                ?.label}
        </p>
      )}
    </Button>
  );
};
